import styled from 'styled-components';
import { rhythm } from 'Themes/typography';

const TicketSearchSection = styled.div`
  padding: ${rhythm(1)};
  border-bottom: 1px solid #ccc;
`;

export default TicketSearchSection;
